import { useTranslation } from "react-i18next";
import * as Yup from "yup";

export function useScenarioCopySchema() {
  const { t } = useTranslation();

  return Yup.object().shape({
    scenarioName: Yup.string().required(t("label.isRequiredValidation", { field: t("label.name") })),
  });
}
